package org.example.project.service

import kotlinx.serialization.builtins.ListSerializer
import kotlinx.serialization.json.Json
import org.example.project.manager.LumaticaApiManager
import org.example.project.utils.All

object UserApi {
    private val json = Json {
        ignoreUnknownKeys = true
        encodeDefaults = false
    }

    suspend fun loadUsers(): List<All> {
        val raw = runCatching { LumaticaApiManager.call("userverwaltung") }.getOrDefault("")
        if (raw.isBlank() || raw == "null") return emptyList()
        return runCatching { json.decodeFromString(ListSerializer(All.AllNames.serializer()), raw) }
            .getOrDefault(emptyList())
    }
}
